<template>
  <div class="flex flex-col items-center justify-center">
    <div :style="{ width: '300px' }" class="flex flex-col w-full">
      <TextInput
        :value="linkUrl"
        :label="'Link URL'"
        :placeholder="'https://www.google.com'"
        :textarea="false"
        :placeholder_black="false"
        :margin_bottom="true"
        :search_icon="false"
        :border_enabled="true"
        :response_selection_id="'linkUrlUpdated'"
      />

      <TextInput
        v-if="!isImage"
        :value="linkTitle"
        :label="'Link title'"
        :placeholder="'e.g., Click here to read more'"
        :textarea="false"
        :placeholder_black="false"
        :margin_bottom="true"
        :search_icon="false"
        :border_enabled="true"
        :response_selection_id="'linkTitleUpdated'"
      />
    </div>

    <div class="flex items-center justify-center">
      <button
        type="button"
        class="btn h-12 mb-0"
        :class="
          canSubmit
            ? isContributor
              ? 'btn-cw-alt'
              : 'btn-primary'
            : 'cursor-not-allowed border-truegray-300 border opacity-50'
        "
        :disabled="!canSubmit"
        @click="saveLink"
      >
        Save
      </button>
    </div>
  </div>
</template>

<script>
import { defineComponent, computed, watch, ref, onMounted } from 'vue'
import { EventBus } from '../../../../../js/plugins/event-bus.js'
import { useStore } from '../../../../../js/store/index.js'
import TextInput from '../../../../../shared/components/InputText.vue'
import {
  validateURL,
  validateURLProtocol,
  updateURLWithProtocol,
} from '../../../../../js/util/helper.js'

export default defineComponent({
  name: 'EditorLinkModal',

  components: {
    TextInput,
  },

  props: {
    config: {
      type: Object,
      default: null,
    },
  },

  setup(props) {
    const store = useStore()
    const isContributor = store.getters['shared/isContributor']
    const linkTitle = ref(props.config?.originalLinkTitle || '')
    const linkUrl = ref(props.config?.originalLinkUrl || '')
    const isImage = props.config?.isImage

    const saveLink = () => {
      if (canSubmit.value) {
        if (!validateURLProtocol(linkUrl.value)) {
          // If they haven't added a URL protocol, add it now on save!
          linkUrl.value = updateURLWithProtocol(linkUrl.value)
        }

        EventBus.$emit('linkDataUpdated', {
          title: linkTitle.value,
          url: linkUrl.value,
        })
        EventBus.$emit('showModal', false)
      }
    }

    const canSubmit = computed(() => {
      if (isImage) {
        return validateURL(linkUrl.value)
      }

      return !!linkTitle.value.length && validateURL(linkUrl.value)
    })

    onMounted(() => {
      EventBus.$on('linkTitleUpdated', (title) => {
        linkTitle.value = title
      })

      EventBus.$on('linkUrlUpdated', (url) => {
        linkUrl.value = url
      })
    })

    return {
      isContributor,
      linkTitle,
      linkUrl,
      isImage,
      saveLink,
      canSubmit,
    }
  },
})
</script>
